import store from '../.././store';

export async function buildEmailFromDb(emailId) {
    try {
      const response = await fetch(`https://html-creator.demo.cartago.com/api/emails/${emailId}`);
      const emailDetails = await response.json();
      const placeholders = emailDetails.email.placeholders 
      const mediaQueries =  emailDetails.email.media
      const reconstructedJson = reconstructEmailJson(emailDetails);
      return {reconstructedJson, placeholders, mediaQueries};
    } catch (error) {
      console.error("Fehler beim Abrufen und Rekonstruieren der Mail:", error);
    }
  }
  

  function reconstructEmailJson(emailDetails) {
    const { email, blocks, rootChildren } = emailDetails;
        
    // Initialisiere das JSON-Objekt mit "root" und grundlegenden Eigenschaften
    const reconstructedJson = {
      root: {
        type: "EmailLayout",
        data: email.data
      },
      title: email.title,
      id: email.id.toString()
    };

    reconstructedJson.root.data.childrenIds = rootChildren.map((id) => id.toString()) // Root-Kinder als Array
  
    // Iteriere durch die Blöcke und füge sie als Schlüssel-Werte-Paare hinzu
    blocks.forEach((block) => {
      const blockId = block.id.toString();
      reconstructedJson[blockId] = {
        type: block.type,
        data: block.data
      };
      if (block.childrenIds && reconstructedJson[blockId].data.props.childrenIds){
        if(block.type == "Ruleset"){
          for (let index = 0;  index < reconstructedJson[blockId].data.props.rules.length; index++){
            reconstructedJson[blockId].data.props.rules[index].conditionalBlock = block.childrenIds[index].toString();
          }
        }
         reconstructedJson[blockId].data.props.childrenIds = block.childrenIds.map(num => num.toString());
      }
      if (block.childrenIds && reconstructedJson[blockId].data.props.columns) {
        for (let columnIndex = 0; columnIndex <  reconstructedJson[blockId].data.props.columns.length; columnIndex++) {
          if(block.childrenIds[columnIndex]) reconstructedJson[blockId].data.props.columns[columnIndex].childrenIds[0]= block.childrenIds[columnIndex].toString();
        }
      }

    });
  
    return reconstructedJson;
  }
  